import { getApiBaseUrl, fetchWithAuth } from './api';
import { okJson } from './httpError';
import type { MinorRelease } from '../pages/minorReleaseDocument';

const base = () => getApiBaseUrl();

/**
 * Termo de liberação para menores — the signed parental authorisation that lets a minor use the
 * facial readers unaccompanied.
 *
 * Submitting one is the guardian's job and happens in the apps; the web only reads and decides.
 */

export async function listMinorReleases(
  customerId: string,
  status?: string,
): Promise<{ success: boolean; data: MinorRelease[] }> {
  const qs = new URLSearchParams();
  if (status) qs.set('status', status);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const r = await fetchWithAuth(`${base()}/api/v1/customers/${customerId}/minor-releases${suffix}`);
  return okJson(r, 'Erro ao carregar os termos de menores');
}

/**
 * Approve or reject. The reason travels on a rejection because the guardian reads it — a refusal
 * they cannot understand is one they will simply file again unchanged.
 */
export async function decideMinorRelease(
  customerId: string,
  releaseId: string,
  approve: boolean,
  reason = '',
): Promise<{ success: boolean; data: MinorRelease }> {
  const r = await fetchWithAuth(
    `${base()}/api/v1/customers/${customerId}/minor-releases/${releaseId}/decide`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ approve, reason }),
    },
  );
  return okJson(r, 'Erro ao registrar a decisão');
}
